import {Menu, Popover} from "antd";
import Button from "@mui/material/Button";
import {MoreVertRounded} from "@mui/icons-material";
import {DoubleLine} from "../../../components/Labels";
import moment from "moment/moment";
import {formatBytes} from "../fileUtils";
import FileIcon from "../../../components/Files/FileIcon";
import TimeCell from "../../../components/TimeCell";
import React from "react";
import TableSearch from "../../../components/TableSearch";
import {FolderOutlined} from "@mui/icons-material";


const actionMenu = (record, showRenameModal, handleDelete) => {
    return (
        <Menu>
            <Menu.Item key="rename" onClick={() => showRenameModal(record.path)}>
                Rename
            </Menu.Item>
            <Menu.Item key="remove" onClick={() => handleDelete(record.path)}>
                Remove
            </Menu.Item>
        </Menu>
    );
}




const FileTable = ({resources, showRenameModal, handleDelete, rowSelection,
                   handleFolderNav})=>{

  let columns = [
    {
      title: 'More',
      key: 'actions',
      width: 70,
      render: (_, record) => (
        <Popover content={actionMenu(record, showRenameModal, handleDelete)} trigger="click" placement="bottomLeft">
          <Button startIcon={<MoreVertRounded />} size="small" />
        </Popover>
      ),
    },
    {
      title: 'Name',
      dataIndex: 'path',
      key: 'path',
      render: (path, record) => {
        const isFolder = path.endsWith('/');
        const name = path.split('/').pop() || path.split('/').slice(-2, -1)[0];
        return (
          <DoubleLine
            titleSize={'0.8rem'}
            title={
              <span
                style={{ cursor: isFolder ? 'pointer' : 'default' }}
                onClick={() => isFolder && handleFolderNav(path)}
              >
                {name}
              </span>
            }
            text={moment(record.created_time).format('MMMM Do YYYY, h:mm:ss a')}
          />
        );
      },
    },
    {
      title: 'Size',
      dataIndex: 'size',
      key: 'size',
      render: (size, record) => record.path.endsWith('/') ? '-' : formatBytes(size),
    },
    {
      title: 'Type',
      dataIndex: 'content_type',
      key: 'content_type',
      render: (type, record) => <FileIcon path={record.path} isFolder={record.path.endsWith('/')} />,
    },
    {
      title: 'Updated',
      dataIndex: 'updated_time',
      key: 'updated_time',
      render: (dateString) => <TimeCell className={'gold-text'} timestamp={new Date(dateString).getTime() / 1000} />,
    },
    {
      title: 'Public URL',
      dataIndex: 'public_url',
      key: 'public_url',
      render: (url, record) => record.path.endsWith('/') ? null : (url ? <a href={url} target="_blank" rel="noopener noreferrer">View</a> : null),
    },
  ];

  return (
      <TableSearch
          columns={columns}
          dataSource={resources}
          rowKey="path"
          rowSelection={rowSelection}
          scroll={{y: '90vh'}}
      />
  )

}

export default FileTable;